import logo from './logo.svg';
import './App.css';
import Sillabuses from './components /Sillabus/Sillabus';
import NavBarNew from './components /CourseNav/NavBarNew';
import FirstScreen from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import AboutMe from './components /me/Me';
import ByMe from './components /ByMe/ByMe';
import MyServices from './components /Services/Services';
import ThirdScreen from './screens/ThirdScreen';
import EyelashCalculator from './components /calculate/Calculate';
import PrivacyPolicy from './privacy/Privacy';

function App() {
  return <>
  <NavBarNew/>
  <FirstScreen/>
  <SecondScreen/>
  <AboutMe/>
  
  <ThirdScreen/>

  <MyServices/>
<PrivacyPolicy 
  ownerName="אדל מושייב" 
  email="adelmosaiv@gmail.com" 
  phone="+972 50-599-1927" 
  domain="adelmoshaev.co.il" 
/>
  <ByMe/>
  </>
}

export default App;
